import { useState } from 'react'
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom'
import { images } from '../services/images.service'
import { HamburgerMenu } from './HamburgerMenu'
import { openLogin, openSignUp } from '../store/slices/ui.slice'
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../store/slices/user.slice'
import { Button } from './ui/elements'
import anizonelogo from '../assets/imgs/anizone-logo.svg'
import { useMediaQuery } from 'react-responsive'
import { UserGreetingMenu } from './UserGreetingMenu'

const menuItems = [
  { id: 1, name: 'אנימות', href: '/animes' },
  { id: 2, name: 'כתבות', href: '/posts' },
  // { id: 3, name: 'מידע למתחיל', href: '/error' },
  { id: 4, name: 'מילון מושגים', href: '/anime-glossary' },
  { id: 8, name: 'המסע ליפן', href: '/japan-trip' },
  { id: 9, name: 'שאלות ותשובות', href: '/faq' },
]

export function Navbar() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isLightMode, setIsLightMode] = useState(false)
  const loggedInUser = useSelector((state) => state.userModule.loggedInUser)
  const isMobile = useMediaQuery({ maxWidth: 1279 })
  function toggleMenu() {
    setIsMenuOpen(!isMenuOpen)
  }

  function toggleLightMode() {
    const newMode = !isLightMode
    setIsLightMode(newMode)

    if (newMode) {
      document.documentElement.classList.add('light')
      document.documentElement.classList.remove('dark')
    } else {
      document.documentElement.classList.add('dark')
      document.documentElement.classList.remove('light')
    }
  }

  const handleLogout = async () => {
    try {
      await dispatch(logout()).unwrap()

      if (isMobile) toggleMenu() // סגירה רק במובייל

      toast.success('התנתקת בהצלחה 👋')
      navigate('/')
    } catch (err) {
      console.error('שגיאה בהתנתקות:', err)
      toast.error('אירעה שגיאה במהלך ההתנתקות')
    }
  }
  return (
    <>
      {/* ה־Navbar כעת Sticky עם top-0 ו־z-index נמוך יחסית (כדי שה־HamburgerMenu יהיה מעליו) */}
      <nav className="sticky top-0 z-50 p-4 flex justify-between items-center border-b border-white/15 bg-[rgba(27,27,27,0.85)] backdrop-blur-sm text-text">
        {/* לוגו */}
        <div className="flex gap-4 items-center">
          <Link to="/">
            <img src={anizonelogo} alt="AniZone Logo" />
          </Link>

          {/* כפתור למצב מואר/כהה (ניתן להפעיל לפי הצורך) */}
          <div className="hidden xl:flex gap-4 justify-between items-center">
            {/* אפשר להוסיף כאן את כפתור המצב */}
          </div>
        </div>

        {/* תפריט עבור דסקטופ */}
        <ul className="hidden xl:flex gap-7 text-softText text-lg">
          {menuItems.map((item) => (
            <li key={item.id}>
              <NavLink
                to={item.href}
                className={({ isActive }) =>
                  `nav__link ${isActive ? 'active text-primary' : ''}`
                }
              >
                {item.name}
                <span className="nav__line-top"></span>
                <span className="nav__line-bottom"></span>
                <span className="nav__diamond nav__diamond-top"></span>
                <span className="nav__diamond nav__diamond-bottom"></span>
              </NavLink>
            </li>
          ))}
        </ul>

        {/* כפתורי משתמש עבור דסקטופ */}
        <div className="hidden xl:flex items-center gap-4">
          {loggedInUser ? (
            <>
              <UserGreetingMenu user={loggedInUser} onLogout={handleLogout} />
            </>
          ) : (
            <div className="flex gap-5 items-center">
              <Button
                text="התחברות"
                width={130}
                height={60}
                fontSize="text-lg"
                textColor="text-softText"
                bgColor="fill-[#363636]"
                onClick={() => dispatch(openLogin())}
                aria-label="התחבר לחשבון שלך"
                title="התחברות"
              />

              <Button
                text="הרשמה"
                width={140}
                height={60}
                fontSize="text-md"
                textColor="text-white"
                bgColor="fill-primary"
                onClick={() => dispatch(openSignUp())}
                icon="https://pub-60946b28fb374ff48942bac3163dd658.r2.dev/uploads/2025/05/registericon-1747116827122.svg"
                aria-label="הירשם לאתר אניזון"
                title="הרשמה"
              />
            </div>
          )}
        </div>

        {/* כפתור Hamburger למובייל/טאבלט */}
        <div className="flex gap-4 xl:hidden">
          {loggedInUser && (
            <Link to={`/user/${loggedInUser.username}`}>
              <img
                src={loggedInUser.image || images.defaultUserIcon}
                alt={loggedInUser.nickname}
                className="h-8 w-8 rounded-full border border-primary"
              />
            </Link>
          )}
          <button
            onClick={toggleMenu}
            className="hover:opacity-80 transition-opacity"
          >
            <img
              src={images.menuWhiteBtn}
              alt="Menu Icon"
              className="h-8 w-8"
            />
          </button>
        </div>
      </nav>

      {/* ה־HamburgerMenu מוצג מחוץ ל־Navbar כדי שלא יהיה מוגבל ע״י stacking context */}
      <HamburgerMenu
        isMenuOpen={isMenuOpen}
        handleLogout={handleLogout}
        toggleMenu={toggleMenu}
        toggleLightMode={toggleLightMode}
        isLightMode={isLightMode}
        menuItems={menuItems}
      />
    </>
  )
}
